$(document).ready(function() {
  
  // Observer Mutations
  function waitforLayout(selector) {
    return new Promise(function (resolve) {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector (selector));
      }
  
      var observer = new MutationObserver(function (mutations) {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          //observer.disconnect ();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  // Will remove the z-index on chat icons when cart drawer is triggered
  function removeIndex() {
    waitforLayout('.menu-opening').then(elm => {
      console.log('cart drawer is active');
      $('#smile-ui-lite-container').css('z-index', '2');
      $('#tidio-chat-iframe').css('z-index', '29');
      $('.needsclick.kl-teaser-Vz3xva').css('z-index', '29');
    });
  }
  
  removeIndex();
  
});

